import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCategory'
})
export class SearchCategoryPipe implements PipeTransform {

  transform(categories: any[], searchTerm?: any, alreadyExist?: any[]): any {
    if (searchTerm === null) {
      return categories;
    }
    searchTerm = searchTerm.indexOf('(C)') > -1 ? searchTerm.substring(searchTerm.indexOf('(C)')+3) : searchTerm;
    const result = categories.filter((con: any) =>
              con.name.toLowerCase().split(',').some((element) =>
                element.includes(searchTerm.toLowerCase()) && alreadyExist.indexOf(element) === -1)
        ) ;

        return result.length === 0 ? [{name: 'No categories found'}] : result;
  }

}
